import { DocumentContentsAccess } from "permissions/entities/permission/resources/documents-resources";
import { ResourceConstructor, Resource } from "permissions/entities/permission/resources/general";
import { LegalEntityAccess } from "permissions/entities/permission/resources/legal-entities-resources";
import { PackedGrid } from "permissions/entities/permission/view/components/permissions-table/styles";
import { JSX } from "react";
import { TableRow } from "permissions/entities/permission/view/components/permissions-table/types";

type SingleGranteeResourceCell = {
  row: TableRow;
  topLevelResources: ResourceConstructor[];
  topLevelTemplates: {
    byConstructor: Map<ResourceConstructor, Resource>;
    legalByAccessType: Map<string, Resource>;
    docContentsBySubject: Map<string, Resource>;
  };
  isSingleGranteeView: boolean;
  isManageTemplatesView?: boolean;
  canEdit: boolean;
  renderLegalEntityCell: (
    row: TableRow,
    topLevelTemplates: {
      byConstructor: Map<ResourceConstructor, Resource>;
      legalByAccessType: Map<string, Resource>;
      docContentsBySubject: Map<string, Resource>;
    },
    isSingleGranteeView: boolean,
    canEdit: boolean
  ) => JSX.Element;
  renderDocumentSubjectMatterCell: (
    row: TableRow,
    topLevelTemplates: {
      byConstructor: Map<ResourceConstructor, Resource>;
      legalByAccessType: Map<string, Resource>;
      docContentsBySubject: Map<string, Resource>;
    },
    isSingleGranteeView: boolean,
    canEdit: boolean
  ) => JSX.Element;
  renderSingleTopLevelPermission: (
    row: TableRow,
    resource: ResourceConstructor,
    canEdit: boolean
  ) => JSX.Element;
};

export default function SingleGranteeResourceCell(
  props: Readonly<SingleGranteeResourceCell>) {
  const {
    row,
    topLevelResources,
    topLevelTemplates,
    isSingleGranteeView,
    isManageTemplatesView,
    canEdit,
    renderLegalEntityCell,
    renderDocumentSubjectMatterCell,
    renderSingleTopLevelPermission
  } = props;

  return (
    <PackedGrid dense={isManageTemplatesView}>
      {topLevelResources.map((resource: ResourceConstructor) => {
        if (resource === LegalEntityAccess) {
          return renderLegalEntityCell(row, topLevelTemplates, isSingleGranteeView, canEdit);
        } else if (resource === DocumentContentsAccess) {
          return renderDocumentSubjectMatterCell(row, topLevelTemplates, isSingleGranteeView, canEdit);
        } else {
          return renderSingleTopLevelPermission(row, resource, canEdit);
        }
      })}
    </PackedGrid>
  );
}
